import { createSlice, current } from "@reduxjs/toolkit";

export const buyingEmails = createSlice({
  name: "buyingEmails",
  initialState: {
    list : [], // TODO: find a way to know that buying emails is loading in all components because is a large object and cause re-rendering in dashboardRouter
  },
  reducers: {
    setBuyingEmailsList: (state, action) => {
      if(action.payload) state.list = action.payload
    },
    updateBuyingEmail: (state, action) => {
      if(action.payload) state.list = state.list.map((BuyingEmail) =>
      BuyingEmail.id == action.payload.id ? action.payload : BuyingEmail
      );
    },
    updateMultipleBuyingEmails: (state, action) => {
      if (action.payload && typeof action.payload === "object" && action.payload.length > 0) {
        action.payload.forEach(email => {
          const emailIndex = state.list.findIndex((e) => e.id === email.id);
          if (emailIndex !== -1) {
            const updatedEmail = { ...state.list[emailIndex], ...email };
            state.list[emailIndex] = updatedEmail;
          }
        });
      }
    },
    addBuyingEmail: (state,action)=>{
      let BuyingEmailExists= state.list.find(x => x.id == action.payload.id)
      if(BuyingEmailExists) console.log("BuyingEmail exists in Redux state, DROP: " + action.payload.id);
      if(action.payload && !BuyingEmailExists) state.list.push(action.payload)
    },
    addbuyingEmails: (state,action ) => {
      const buyingEmails = action.payload;

      if(state.list == null || state.list == undefined){
        state.list = buyingEmails;
        return;
      }

      buyingEmails.forEach(email => {
        const emailIndex = state.list.findIndex((e) => e.id == email.id);
        if (emailIndex !== -1) {
          state.list[emailIndex] = email;
        } else {
          state.list.push(email);
        }
      })
    }
  }
});

export default buyingEmails.reducer

export const selectAllEmails = state=>state.buyingEmails.list

export const selectAllActiveEmails = state=>state.buyingEmails.list.filter(x=>x.active)

export const selectAllInactiveEmals = state=>state.buyingEmails.list.filter(x=>!x.active)

export const selectEmailByUserId = (state, userId) =>
  state.buyingEmails.list.filter((email) => email.assignedUserID === userId);

export const selectActiveEmailsByUserId = (state, userId) => state.buyingEmails == null ? [] :
  state.buyingEmails.list.filter((email) => email.assignedUserID === userId && email.isActive);

export const selectInactiveEmailsByUserId = (state, userId) =>
  state.buyingEmails.list.filter((email) => email.assignedUserID === userId && !email.isActive);

export const {setBuyingEmailsList, updateBuyingEmail, updateMultipleBuyingEmails, addBuyingEmail,addbuyingEmails} = buyingEmails.actions
